<div id="diagramCommentsButton" style="color: #676a6c; height: 28px; width: 28px; overflow: hidden"></div>
